export default function () {
  const hashComponents = window.location.hash.substring(1).split('&')

  const data = {}

  for (let i = 0; i < hashComponents.length; i++) {
    const dividerPosition = hashComponents[i].indexOf('=')

    const key = hashComponents[i].substring(0, dividerPosition)
    const value = decodeURIComponent(hashComponents[i].substring(dividerPosition + 1))

    data[key] = value
  }

  return data
}
